/**
 * WappGrow product suite — add entries here to surface new apps in the launcher.
 *
 * @typedef {Object} AppsLauncherItem
 * @property {string} id - Stable unique id
 * @property {string} name - Display name
 * @property {string} description - Short helper text
 * @property {string} iconKey - Key mapped to an icon in AppsLauncher
 * @property {string} [route] - In-app path (react-router)
 * @property {string} [href] - External URL (opens in new tab when openInNewTab is true)
 * @property {boolean} [openInNewTab] - Open href in a new tab
 */

export const STORES_APP_URL = process.env.REACT_APP_ESTORE_MERCHANT_URL
  || process.env.REACT_APP_STORES_URL
  || "http://app.localhost:8080/account";

/** @type {AppsLauncherItem[]} */
export const appsLauncherItems = [
  {
    id: "stores",
    name: "Stores",
    description: "Manage your online stores",
    iconKey: "storefront",
    href: STORES_APP_URL,
    openInNewTab: true,
  },
];
